<template>
  <div
    class="cardRecentIndicators"
    data-epica-module-name="Indicadores Recientes"
    v-if="quoteData && quoteData.length"
  >
    <h3 class="nameIndicator">RECIENTES</h3>

    <a v-for="quote in quoteData" :key="quote.id" :href="quote.url">
      <div class="d-flex recentIndicators align-items-center">
        <div class="col-5 p-0">
          <span class="nameIndicator" v-html="quote.name"></span>
        </div>
        <div class="col-7 p-0 text-right">
          <span class="varAbs" v-html="quote.value"></span>
          <i :class="'icon-' + quote.upDownClass + ' ' + quote.upDownClass"></i>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import lrLocalStorage from "../../../features/lr-localstorage";
import { RECENT_QUOTES_LS } from "../../../constants/constants";
export default {
  props: {
    quoteId: String,
  },
  mounted: function () {
    if (this.quoteId) {
      this.addRecentQuote();
    } else {
      this.readRecentQuotes();
    }
    this.getQuoteData();
  },
  methods: {
    addRecentQuote() {
      let rec_quo = lrLocalStorage.getItem(RECENT_QUOTES_LS);
      if (!rec_quo) {
        this.rec_quo_arr = [this.quoteId];
        rec_quo = JSON.stringify([this.quoteId]);
      } else {
        this.rec_quo_arr = JSON.parse(rec_quo);
        this.rec_quo_arr.unshift(this.quoteId);
        //Remove duplicates
        this.rec_quo_arr = this.rec_quo_arr
          .filter((ele, pos, arr) => {
            return arr.indexOf(ele) === pos;
          })
          .slice(0, 4);
      }
      lrLocalStorage.setItem(
        RECENT_QUOTES_LS,
        JSON.stringify(this.rec_quo_arr)
      );
    },
    readRecentQuotes() {
      let rec_quo = lrLocalStorage.getItem(RECENT_QUOTES_LS);
      this.rec_quo_arr = rec_quo ? JSON.parse(rec_quo) : null;
    },
    getQuoteData() {
      if (this.rec_quo_arr && this.rec_quo_arr.length) {
        const _self = this;
        axios
          .get("/api/quote/recent-quotes", {
            params: {
              qIds: this.rec_quo_arr,
            },
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          })
          .then(function (d) {
            _self.quoteData = d.data;
          });
      }
    },
  },
  data: () => {
    return {
      rec_quo_arr: null,
      quoteData: null,
    };
  },
};
</script>